import { createTheme, MantineColorsTuple } from '@mantine/core';

// Color palette matching main application
const blueGray: MantineColorsTuple = [
  "#f1f4fe",
  "#e4e6ed",
  "#c8cad3",
  "#a9adb9",
  "#9094a3",
  "#7f8496",
  "#777c91",
  "#63687c",
  "#595e72",
  "#4a5167",
];

const brightBlue: MantineColorsTuple = [
  "#e5f3ff",
  "#cde2ff",
  "#9ac2ff",
  "#64a0ff",
  "#3884fe",
  "#1d72fe",
  "#0063ff",
  "#0058e4",
  "#004ecd",
  "#0043b5",
];

export const theme = createTheme({
  primaryColor: 'brightBlue',
  colors: {
    blueGray,
    brightBlue,
  },
  fontFamily: 'Montserrat, sans-serif',
  headings: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '600',
  },
  breakpoints: {
    xxl: "1920px",
  },
  defaultRadius: 'md',
  components: {
    Tooltip: {
      defaultProps: {
        withArrow: true,
        arrowSize: 8,
        arrowPosition: "center",
        fz: "xs",
        color: "dark",
        transition: "fade",
      },
    },
    Combobox: {
      styles: {
        dropdown: {
          borderColor: "var(--mantine-color-default-border)",
        },
      },
      defaultProps: {
        withinPortal: false,
        offset: 0,
        shadow: "md",
        transitionProps: { transition: "fade-down", duration: 100 },
      },
    },
    Menu: {
      styles: {
        dropdown: {
          borderColor: "var(--mantine-color-default-border)",
        },
      },
      defaultProps: {
        withinPortal: false,
        offset: 0,
        shadow: "md",
        transitionProps: { transition: "fade-down", duration: 100 },
      },
    },
    Select: {
      styles: {
        dropdown: {
          borderColor: "var(--mantine-color-default-border)",
        },
      },
      defaultProps: {
        checkIconPosition: "right",
        comboboxProps: {
          offset: 0,
        },
      },
    },
    Popover: {
      styles: {
        dropdown: {
          borderColor: "var(--mantine-color-default-border)",
        },
      },
      defaultProps: {
        withinPortal: false,
        offset: 0,
        shadow: "md",
        transitionProps: { transition: "fade-down", duration: 100 },
      },
    },
  },
});
